import React, { useState, useRef, useEffect } from 'react';
import { Formik, Field, Form } from 'formik';
import { useParams } from 'react-router';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import FormikInputField from 'components/common/Fields/FormikInputField';
import useAxios from 'hooks/useAxios';
import { Card, CardBody, Container, Label, Col, Row, ButtonGroup, Button, Input } from "reactstrap";
import ErrorBoundary from "components/ErrorBoundary";
import ReactStrapTable from 'components/reactStrapTable';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import { cellRendererCheck, currencyFormat, dateFormate } from 'utils/columns';
import Confirm from 'components/Confirm';
//import claimsData from 'pages/PurchaseOrder/PurchaseTable/components/ClaimsHelper';
import save from 'assets/icon/save.svg';


let checkedIds = [];
let allcheckids = [];

const EditClaims = (props) => {
    const { claimData, tenantID, setEditDrawer, refetch } = props;
    const API = useAxios();
    const { rxNumber, hasEditable = true, onClose } = props;
    const [data, setData] = useState([]);
    const [defaultCaptureData, setDefaultCaptureData] = useState([]);
    const [isDeleteConfirm, setDeleteConfirm] = useState(false);
    const [allCheckDefault, setAllCheckDefault] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [commentID, setCommentID] = useState(-1);
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isConfirm, setConfirm] = useState(false);
    const [selectedCaptureType, setSelectedCaptureType] = useState(1);
    const [totalSavings, setTotalSavings] = useState(0);


    const [associateRefillSelected, setAssociateRefillSelected] = useState(true);
    const [futureRefillSelected, setFutureRefillSelected] = useState(true);

    let claimCaptureTypesData = [];
    claimCaptureTypesData.push({ "id": 1, "description": "Manual Capture" });
    claimCaptureTypesData.push({ "id": 2, "description": "Referral Capture" });


    const [files, setFiles] = useState([]);
    const formikRef = useRef();

    const fetchClaimRefillsData = async () => {
        setLoading(true);
        checkedIds = [];
        allcheckids = [];
        setSelectedIds([]);
        if (claimData) {
            try {
                const { data } = await API.get(
                    `/${tenantID}/RxManager/getrefills/${claimData.gwClaimID}`,
                    {
                        hideLoader: true,
                    }
                );
                setData(data);
                setDefaultCaptureData(data.filter(item => item.gwClaimID == claimData.gwClaimID));
                (data);
                if (data.length === 1)
                    setAllCheckDefault(true);
                for (var x in data) {
                    allcheckids.push(data[x].gwClaimID);
                    checkedIds.push(data[x].gwClaimID);
                }

                setSelectedIds([...allcheckids]);
                setLoading(false);
            } catch (error) { }
        }

    };

    const calculateTotalSavings = () => {
        var total = 0;
        var totalvalues = data.filter((item) => checkedIds.includes(item.gwClaimID));
        if (Array.isArray(totalvalues)) {
            let totals = totalvalues.map(item => item["savings340B"]);
            for (var i = 0; i < totals.length; i++) {
                total = total + totals[i];
            }
            setTotalSavings(total);
        }
    }

    useEffect(() => {
        fetchClaimRefillsData();
    }, []);

    const handleSubmit = async (values, actions) => {
        const { comment } = values;
        const { setErrors } = formikRef.current;
        if (!comment.trim()) return setErrors({ comment: 'Enter valid comment' });
        const fileObject = {};
        files.map((f, i) => {
            fileObject['file' + (i + 1)] = f;
            return f;
        });
        setSubmitting(true);
    };

    const handleAllCheckbox = (e) => {
        setAllCheckDefault(e.target.checked);
        checkedIds = [];

        if (e.target.checked) {
            allcheckids = [];
            if (allcheckids.length === 0) {
                for (var x in data) {
                    allcheckids.push(data[x].gwClaimID);
                    checkedIds.push(data[x].gwClaimID);
                }
            }
        }
        else {
            setSelectedIds([]);
            allcheckids = [];
            checkedIds = [];
            allcheckids.push(claimData.gwClaimID);
            checkedIds.push(claimData.gwClaimID);
        }
        setSelectedIds([...allcheckids]);

        calculateTotalSavings();
    }

    const renderCheckbox = (claim) => {
        calculateTotalSavings();
        const filter = selectedIds.filter((item) => item === claim.gwClaimID);
        return (
            <Input disabled={claim.gwClaimID === claimData.gwClaimID ? true : false}
                onChange={() => onChange(claim)}
                type='checkbox'
                className='me-2 mt-0'
                value={filter.length > 0}
                checked={filter.length > 0 ? true : false}
            //defaultChecked={true}
            />);
    }

    const onChange = (claim) => {
        const { gwClaimID, rxNumber, providerID } = claim;
        const index = checkedIds.indexOf(gwClaimID);
        if (checkedIds.length === 0) {
            checkedIds.push(gwClaimID);
        } else {
            if (index >= 0) {
                checkedIds.splice(index, 1);

            } else {
                checkedIds.push(gwClaimID);
            }
        }
        if (checkedIds.length === data.length) {
            setAllCheckDefault(true);
        }
        else {
            setAllCheckDefault(false);
        }
        setSelectedIds([...checkedIds]);
        calculateTotalSavings();
    };

    const mainCol = [
        {
            text: <Input type="checkbox" disabled={data.length === 1} title={allcheckids.length == 0 ? "select all" : "unselect all"} onChange={(e) => { handleAllCheckbox(e) }} hidden={data.length == 0} checked={allCheckDefault} />,
            cellRenderer: (rowData) => renderCheckbox(rowData),
            width: 70,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
            text: 'Select'
        },
        {
            dataField: 'refillNumber',
            text: 'Refill #',
            width: 90,
            show: true,
            sort: false,
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.refillNumber),
        },

        {
            dataField: 'dateOfService',
            text: 'Date of Service',
            width: 130,
            show: true,
            sort: false,
            hideColFilter: true,
            cellRenderer: (row) => dateFormate(row.dateOfService),
        },
        {
            dataField: 'drugName',
            text: 'Drug Name',
            width: 255,
            show: true,
            sort: false,
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.drugName),
        },
        {
            dataField: 'ndc',
            text: 'NDC',
            width: 120,
            show: true,
            sort: false,
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.ndc),
        },
        {
            dataField: 'metricQuantity',
            text: 'Dispensed Quantity',
            width: 130,
            show: true,
            sort: false,
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.metricQuantity),
        },
        {
            dataField: 'ceReceivables',
            text: 'CE Receivables',
            width: 120,
            inputType: 'number',
            show: true,
            sort: false,
            hideColFilter: true,
            cellRenderer: (row) => currencyFormat(row.ceReceivables),
        },
        {
            dataField: 'totalpaid',
            text: 'Total Paid',
            width: 120,
            show: true,
            sort: false,
            hideColFilter: true,
            inputType: 'number',
            cellRenderer: (row) => currencyFormat(row.totalpaid),
        },
        {
            dataField: 'customDispenseFee',
            text: 'Dispensing Fee',
            width: 120,
            show: true,
            sort: false,
            hideColFilter: true,
            inputType: 'number',
            cellRenderer: (row) => currencyFormat(row.customDispenseFee),
        },
        {
            dataField: 'savings340B',
            text: '340B Savings',
            show: true,
            sort: false,
            hideColFilter: true,
            width: 120,
            cellRenderer: (row) => cellRendererCheck(row.savings340B),
        },
    ];

    const onChangeCaptureType = async (e) => {
        const { value } = e.target;
        setSelectedCaptureType(value);
    }

    const handleSaveConfirmation = () => {
        setConfirm(!isConfirm);
    };

    const handleUpadte = async () => {
        handleSaveConfirmation();
        try {
            setLoading(true);
            let payload = {};
            payload.ClaimStatusID = parseInt(claimData.claimStatusID);
            payload.Reason = payload.ClaimStatusID === 9003 ? selectedCaptureType : 0;
            payload.IsAssociateRefills = associateRefillSelected;
            payload.IsFutureRefills = futureRefillSelected;
            payload.ActualClaimID = claimData.gwClaimID;
            payload.ClaimIDs = [];
            if (associateRefillSelected)
                payload.ClaimIDs = checkedIds;
            else
                payload.ClaimIDs.push(claimData.gwClaimID);
            const { data } = await API.post(
                `/${tenantID}/RxManager/rxmanagerupdate`,
                payload
            );
            if (data) {
                setLoading(false);
                setAllCheckDefault(false);
                toast.success('Claims updated successfully');
                refetch();
                setEditDrawer(false);
            }
        } catch (error) {
            setLoading(false);
        }
    };

    return (
        <div
        >
            <Container>
                <Card>
                    <CardBody>
                        <ErrorBoundary>
                            <Row>
                                <Col md={3}>
                                    <Label>
                                        Change Claim Type To
                                    </Label>
                                </Col>
                                <Col md={1}>
                                    : &nbsp;&nbsp;
                                </Col>
                                <Col md={3}>
                                    {
                                        claimData.claimStatusID == 9002 ? (<span>
                                            Non-Captured
                                        </span>
                                        ) : (<span>
                                            Captured
                                        </span>)}
                                </Col>
                            </Row>
                            <Col md={1}>
                                &nbsp;
                            </Col>
                            <Row>
                                <Col md={3}>
                                    <Label>
                                        Reason
                                    </Label>
                                </Col>
                                <Col md={1}>
                                    :&nbsp;&nbsp;
                                </Col>
                                <Col md={3}>
                                    {
                                        claimData.claimStatusID == 9002 ? (<span>
                                            Manual Non-Capture
                                        </span>
                                        ) : (
                                            <span> Manual Capture</span>
                                        )}
                                </Col>
                            </Row>
                            <Col md={1}>
                                &nbsp;
                            </Col>
                            <Row>
                                <Col md={3}>{
                                    claimData.claimStatusID == 9002 ? (<Label>
                                        Non-Capture Associated Refills
                                    </Label>
                                    ) : (<Label>
                                        Capture Associated Refills
                                    </Label>)}
                                </Col>
                                <Col md={1}>
                                    :&nbsp;&nbsp;
                                </Col>
                                <Col md={3}>
                                    <ButtonGroup className='filter-btn-group'>

                                        <Button
                                            color='info'
                                            outline
                                            onClick={() => setAssociateRefillSelected(true)}
                                            active={associateRefillSelected}
                                            disabled={false}
                                        >
                                            YES
                                        </Button>
                                        <Button
                                            color='info'
                                            outline
                                            onClick={() => setAssociateRefillSelected(false)}
                                            active={!associateRefillSelected}
                                            disabled={false}
                                        >
                                            NO
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                            <Col md={1}>
                                &nbsp;
                            </Col>
                            <Row>
                                <Col md={3}>{
                                    claimData.claimStatusID === 9002 ? (<Label>
                                        Non-Capture Future Refills
                                    </Label>
                                    ) : (<Label>
                                        Capture Future Refills
                                    </Label>)}


                                </Col>
                                <Col md={1}>
                                    :&nbsp;&nbsp;
                                </Col>
                                <Col md={3}>
                                    <ButtonGroup className='filter-btn-group'>

                                        <Button
                                            color='info'
                                            outline
                                            onClick={() => setFutureRefillSelected(true)}
                                            active={futureRefillSelected}
                                            disabled={false}
                                        >
                                            YES
                                        </Button>

                                        <Button
                                            color='info'
                                            outline
                                            onClick={() => setFutureRefillSelected(false)}
                                            active={!futureRefillSelected}
                                            disabled={false}
                                        >
                                            NO
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </ErrorBoundary>
                    </CardBody>
                    <CardBody>
                        {associateRefillSelected ? (
                            <div>
                                <ErrorBoundary>
                                    <div className='table-card scroll-table position-relative border-0 rounded pt-0'
                                        fixed-height={data.length > 0 ? 'fixed-height' : 'default'}>
                                        <ReactStrapTable
                                            id='rx-manager-edit-table'
                                            columns={mainCol}
                                            fixedColumn
                                            loading={loading}
                                            data={data}
                                        />
                                    </div>
                                </ErrorBoundary>
                                <Row className='mt-2'>
                                    {/* <Col md={}></Col> */}
                                    <Col md={12} style={{ textAlignLast: "end" }}>Total Savings:{currencyFormat(totalSavings)}</Col>
                                </Row>
                            </div>
                        ) : (
                            <div>
                                <ErrorBoundary>
                                    <div className='table-card scroll-table position-relative border-0 rounded pt-0'
                                        fixed-height={defaultCaptureData.length > 0 ? 'fixed-height' : 'default'}>
                                        <ReactStrapTable
                                            id='rx-manager-edit-table'
                                            columns={mainCol}
                                            loading={loading}
                                            fixedColumn
                                            data={defaultCaptureData.length > 0 ? [defaultCaptureData[0]] : []}
                                        />
                                    </div>
                                </ErrorBoundary>
                                <Row className='mt-2'>
                                    {/* <Col md={}></Col> */}
                                    <Col md={12} style={{ textAlignLast: "end" }}>Total Savings:{currencyFormat(defaultCaptureData[0].savings340B)}</Col>
                                </Row>
                            </div>
                        )
                        }
                        <Row className='d-flex' style={{ justifyContent: "flex-end" }}>
                            {/* <Col md={11}></Col> */}
                            <Col md='auto mt-3'>

                                <Button
                                    color='primary'
                                    className='search'
                                    onClick={handleSaveConfirmation}
                                >
                                    <span className='right_5'><img src={save} alt="" /></span> Save
                                </Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Container>
            <Confirm
                isOpen={isConfirm}
                loading={loading}
                message='Are you sure you want to update?'
                onToggle={handleSaveConfirmation}
                onCancel={handleSaveConfirmation}
                onContinue={handleUpadte}
            />
        </div>
    )
}
export default EditClaims;
